import { liftFor } from '@full-elevator/content';
import type { Lift } from '@full-elevator/sim';
import { STANDARD_LIFT } from '@full-elevator/sim';

/**
 * A building's own lift (ADR-0027), or the standard one: the Office Tower's,
 * and the lift of any level that names no building.
 */
export function buildingLift(buildingId: string | undefined): Lift {
  return liftFor(buildingId) ?? STANDARD_LIFT;
}
